import type { IGenModalOnButton } from "@/services/graphql/__generated/sdk";
import { cn } from "@/utils/tailwind-helper";
import { component$ } from "@builder.io/qwik";
import { ContactForm } from "../contact-form-modal/ContactFormModal";
import { useUniversalText } from "~/hooks/useCMSData";

export interface ModalOnButtonProps extends IGenModalOnButton {
    componentIndex?: number;
    showContactForm?: boolean;
    universalText?: any;
    titleOverwrite?: string;
    id?: string | null;
}

export const ModalOnButton = component$((props: ModalOnButtonProps) => {
    const { showContactForm = true, titleOverwrite, id } = props;
    const universalText = useUniversalText();

    return (
        <section class={cn("flex flex-col gap-8")}>
            {showContactForm && (
                <div class="p-4 silver:w-[calc(834px_-_131px)] silver:p-0 silver:px-8 silver:py-20 gold:w-[calc(1280px_-_550px)] gold:p-20 platinum:w-[calc(1440px_-_732px)]">
                    <ContactForm
                        caisyFormId={id}
                        titleOverwrite={titleOverwrite}
                        universalText={universalText}
                        salutationDropdownWidth="platinum:w-[calc((708px_-_160px)_/_2_-_6px)] gold:w-[calc((730px_-_160px)_/_2_-_6px)] silver:w-[calc((703px_-_64px)_/_2_-_6px)] bronze:w-[calc((375px_-_32px))] "
                        countryDropDownWidth="platinum:w-[calc((708px_-_160px))] gold:w-[calc((730px_-_160px))] silver:w-[calc((703px_-_64px))] bronze:w-[calc((375px_-_32px))] "
                    />
                </div>
            )}
        </section>
    );
});
